import React from 'react';

import { Box, Button, Stack, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import PropTypes from 'prop-types';

import { COLORS } from '../../Constant/COLORS';

const ErrorState = ({
  title = "Something didn't load",
  message = "We couldn't fetch this section. Please try again.",
  onRetry,
  retryLabel = 'Try again',
  minHeight = 240,
  compact = false,
}) => (
  <Box
    width='100%'
    display='flex'
    alignItems='center'
    justifyContent='center'
    minHeight={minHeight}
    px={2}
  >
    <Stack alignItems='center' gap={1.5} textAlign='center' maxWidth={420}>
      <ErrorOutlineIcon sx={{ fontSize: compact ? 36 : 52, color: '#c0392b' }} />
      <Typography variant={compact ? 'subtitle1' : 'h6'} fontWeight={600}>
        {title}
      </Typography>
      <Typography variant='body2' color='text.secondary'>
        {message}
      </Typography>
      {onRetry && (
        <Button
          variant='outlined'
          onClick={onRetry}
          sx={{ mt: 1, color: COLORS.blue, borderColor: COLORS.blue }}
        >
          {retryLabel}
        </Button>
      )}
    </Stack>
  </Box>
);

ErrorState.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  onRetry: PropTypes.func,
  retryLabel: PropTypes.string,
  minHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  compact: PropTypes.bool,
};

export default ErrorState;
